module.exports = __webpack_public_path__ + "img/head-side-brain.8ca19083.svg";